import { useQuery } from "@apollo/client";
import {
  GetUsersForSchoolDocument,
  GetUsersForSchoolQuery,
  User,
  UserRoleEnum,
} from "../../../generated/graphql";
import { useRequestError } from "../../../hooks";
import { Autocomplete } from "@material-ui/lab";
import { ErrorMessageSnackbar } from "../../shared/ErrorMessageSnackbar";
import { LoadingProgress } from "../../shared/LoadingProgress";
import { StyledTextField } from "../Style";
import { QUERY_LIMIT } from "../constants";

interface SelectManagerProps {
  managerId: string;
  inputError: boolean;
  setManagerId: (managerId: string) => void;
}

export const SelectManager = ({ managerId, inputError, setManagerId }: SelectManagerProps) => {
  const { data, loading, error } = useQuery<GetUsersForSchoolQuery>(GetUsersForSchoolDocument, {
    variables: {
      getUsersData: {
        limit: QUERY_LIMIT,
        skip: 0,
        roles: [UserRoleEnum.Super, UserRoleEnum.Manager],
      },
    },
  });

  const { requestError, setRequestError, errorMessage } = useRequestError(
    error,
    "При загрузке списка пользователей произошла ошибка",
  );

  if (loading) {
    return <LoadingProgress />;
  }

  const users = data?.getUsers?.users as User[] ?? [];

  return (
    <>
      <Autocomplete
        options={users.map((users) => users.id)}
        getOptionLabel={(option) => {
          const user = users.find((users) => users.id === option);
          return `${user?.firstName} ${user?.lastName}`;
        }}
        onChange={(_, value) => setManagerId(value)}
        value={users.find((users) => users.id === managerId)?.id || null}
        renderInput={(params) => (
          <StyledTextField
            label="Менеджер"
            variant="filled"
            error={inputError}
            {...params}
          />
        )}
      />

      <ErrorMessageSnackbar
        open={requestError}
        message={errorMessage}
        closeHandler={() => setRequestError(false)}
      />
    </>
  );
};
